import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from "react-router-dom";

function AdminPayment() {
  const { network } = useParams();
  const [loading, setLoading] = useState(false);
  const [billamount, setAmount] = useState([]);

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const user = getCookie("user");
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return value;
    }
    return null;
  }
  if (!user) navigate("/");
  const handlePay = async () => {
  
    setLoading(true);
    try {
      const response = await axios.post('https://node.cabletvpay.in/adminwebpayment', {
        username: network,
        amount: billamount?.cost
      });
  
      toast.success(response.data.message || "Payment successful!");
      setTimeout(() => {
        navigate("/adminOperator");
      }, 1500);
    } catch (error) {
      toast.error("Payment failed!");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  async function fetchUserData() {
    try {
      const response = await axios.post('https://node.cabletvpay.in/adminbill', { network });
      if (response.status === 200) {
        console.log(response.data);
        setAmount(response.data.amount)

      }
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching data");
      toast.error(err.response?.data?.message || "Error fetching data")
      console.log(err);
    } finally {
      setLoading(false);

    }
  }
  useEffect(() => {
    fetchUserData();
  }, [user]);
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light w-100">
        <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
      <div
        className="card shadow-lg w-auto elevation-3"
        style={{
          borderRadius: '1.5rem',
          border: 'none',
          animation: 'fadeIn 0.6s ease-in-out',
          boxShadow: '0 0 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div
          className="card-header text-center text-white w-auto"
          style={{
            background: 'linear-gradient(90deg, #f44336, #e57373)',
            borderTopLeftRadius: '1.5rem',
            borderTopRightRadius: '1.5rem',
            padding: '1.5rem 1rem',
          }}

        >
          <h2 className="fw-bold mb-0">⚠️Please Pay Your Bill Payment</h2>
        </div>

        <div className="card-body text-center px-4 py-5">
          <span className="badge bg-warning text-dark mb-3 px-3 py-2 fs-6 rounded-pill">
            Network Name:{network}
          </span>
         <h4 className="text-primary fw-bold mb-4">
  Bill Amount: ₹ <span className="text-dark">{billamount?.cost}</span>
</h4>

          <button
            onClick={handlePay}
            className="btn btn-info btn-lg px-5 py-2 rounded-pill shadow-sm d-inline-flex align-items-center gap-2"
            disabled={loading}
          >
            {loading ? "Processing..." : <> <i className="bi bi-google"></i>Pay</>}
          </button>

        </div>
      </div>

      {/* Animation + Bootstrap Icons CDN */}
      <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>

    </div>
  );
}

export default AdminPayment;
